module.exports = __webpack_public_path__ + "static/media/mar 2021.c03d6834.svg";